import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=a6df4276&scoped=true"
import script from "./Endereco.vue?vue&type=script&lang=ts"
export * from "./Endereco.vue?vue&type=script&lang=ts"
import style0 from "./Endereco.vue?vue&type=style&index=0&id=a6df4276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6df4276",
  null
  
)

export default component.exports